import { PropertyManagementSystem } from "types/landlord/partner";

export enum SyncOption {
  NEVER = "never",
  FIRST_SYNC = "first_time",
  EVERY_SYNC = "every"
}

export const SyncOptionLabels = {
  [SyncOption.NEVER]: "Never",
  [SyncOption.FIRST_SYNC]: "Only first sync",
  [SyncOption.EVERY_SYNC]: "Every sync"
};

export const PMSNames: Record<PropertyManagementSystem, string> = {
  [PropertyManagementSystem.APPFOLIO]: "Appfolio",
  [PropertyManagementSystem.BUILDIUM]: "Buildium",
  [PropertyManagementSystem.RENT_MANAGER]: "Rent Manager",
  [PropertyManagementSystem.RENTVINE]: "Rentvine",
  [PropertyManagementSystem.RESMAN]: "Resman",
  [PropertyManagementSystem.RENTERS_WAREHOUSE]: "Renters Warehouse",
  [PropertyManagementSystem.MANAGE_AMERICA]: "ManageAmerica",
  [PropertyManagementSystem.ENTRATA]: "Entrata",
  [PropertyManagementSystem.QUEXT]: "Quext",
  [PropertyManagementSystem.YARDI]: "Yardi",
  [PropertyManagementSystem.OTHER]: "Other"
};
